export default __webpack_public_path__ + "static/media/consulter-cagnotefid.ee3e5fe9.jpg";